import { Card } from '@gomi/component';
import { ResponsiveBar } from '@nivo/bar';
import { max } from 'lodash-es';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useTopSellingBrands } from '@/hooks/home/useTopSellingBrands';
import { getTextWidth } from '@/lib/getTextWidth';
import { useStore } from '@/stores';
import { HomeEmpty } from '@/views/home/Empty';

export const padding: { [key: number]: number } = {
  0: 0,
  1: 0.75,
  2: 0.6,
  3: 0.45,
  4: 0.35,
  5: 0.2,
};

export const TopSellingBrands = observer(() => {
  const { t } = useTranslation(['home']);
  const {
    homeModel: { startDate, endDate },
  } = useStore();
  const { data, isLoading } = useTopSellingBrands({
    startDate,
    endDate,
  });
  const chartData = data.sort((a, b) => a.count - b.count);
  return (
    <Card header={t('home:dashboard.topSellingBrand.title')} loading={isLoading}>
      <div className='gm-h-[12rem] gm-text-sm'>
        {(!data.length && <HomeEmpty />) || null}
        {(data.length && (
          <ResponsiveBar
            data={chartData}
            keys={['count']}
            indexBy='brandKrName'
            margin={{
              top: 0,
              right: 0,
              bottom: 0,
              left: max(
                chartData.map((item) => getTextWidth(item.brandKrName, '11px', 25)),
              ),
            }}
            padding={padding[chartData.length]}
            valueScale={{ type: 'linear' }}
            indexScale={{ type: 'band', round: true }}
            colors={(bar) => (bar.index !== data.length - 1 ? '#D9D9D9' : '#1890FF')}
            layout='horizontal'
            enableGridY={false}
            enableGridX={false}
            borderColor={{
              from: 'color',
              modifiers: [['darker', 1.6]],
            }}
            axisTop={null}
            axisRight={null}
            axisBottom={null}
            labelTextColor={{
              from: 'color',
              modifiers: [['darker', 1.6]],
            }}
            role='application'
          />
        )) ||
          null}
      </div>
    </Card>
  );
});
